import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import {
  Weddings,
  CancionAMedida,
  Setups,
  Process,
  FAQ,
  FinalCTA,
} from "@/components/landing/Sections";
import { ScrollBodas } from "@/components/landing/ScrollBodas";

export const Route = createFileRoute("/bodas")({
  head: () => ({
    meta: [
      { title: "Bodas · SUSIEDAD" },
      {
        name: "description",
        content:
          "DJ para bodas. Cóctel, comida o cena y fiesta, con preparación musical previa con la pareja y un portal privado para dejarlo todo escrito.",
      },
    ],
  }),
  component: () => (
    <div className="min-h-screen bg-background text-foreground">
      {/* La página abre con una escena a sangre, así que la cabecera flota
          encima en hueso en vez de empujarla hacia abajo. */}
      <SiteHeader overlay />
      <main>
        <ScrollBodas />
        <Weddings />
        <CancionAMedida />
        <Setups />
        <Process />
        <FAQ />
        <FinalCTA />
      </main>
      <SiteFooter />
    </div>
  ),
});
